import React from 'react'
import { Loader } from '@web/walter-ui-kit'

import styles from './style.module.css'

export function Preloader() {
    return (
        <div className={styles.menu}>
            {Array.from({ length: 5 }).map((_, index) => (
                <div key={index} className={styles.tab}>
                    <Loader isCircled width={24} height={24} />
                    <Loader width="50%" height={20} />
                    <div className={styles.icon}>
                        <Loader width={18} height={24} />
                    </div>
                </div>
            ))}
        </div>
    )
}
